var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        [
          _c(_vm.component, {
            tag: "component",
            attrs: { pidInfo: _vm.pidInfo },
            on: {
              "update:pidInfo": function ($event) {
                _vm.pidInfo = $event
              },
              "update:pid-info": function ($event) {
                _vm.pidInfo = $event
              },
            },
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }